import React from "react";
import { S3_MENU_THUMBNAIL_FOLDER } from "../../store/constants";
import { useSelector } from "react-redux";

const ChefCardDailyDishCard = ({
  index,
  onSpecialDishClick,
  dailySpecialCatId,
  dish,
  dailySpecialDishes,
}) => {
  const dishWithPrice = useSelector((state) => state.dish.dishWithPrice);
  const dishId = dish._id;
  const dishPrice = dishWithPrice[dishId];

  return (
    <div
      key={index}
      className="dailySpecialDishesContainer"
      onClick={() => onSpecialDishClick(dailySpecialCatId)}
    >
      <div className="dailySpecialLeftContainer">
        <div className="dailySpecialDishImageParent">
          <img
            className="dailySpecialDishImage"
            src={dish.img ? S3_MENU_THUMBNAIL_FOLDER + dish.img : ""}
            alt="Dish image"
          />
        </div>
        <div className="dailyMealsContainer">
          <span className="dailyMealsLabel Satoshi gradient-text">
            Daily Meals - {dish.type === "veg" ? "Veg" : "Non-Veg"}
          </span>
          <span className="dailyMealsDesc Satoshi">{`${dish.name} @ ₹${dishPrice || dish.price}`}</span>
        </div>
      </div>
      <div className="dailySpecialCount Satoshi">{`${index + 1}/${
        dailySpecialDishes.length
      }`}</div>
    </div>
  );
};

export default ChefCardDailyDishCard;
